import React, { useState } from "react";
import "./OurPlans.css";
import { Link } from "react-router-dom";
import currentPlanImg from "../../Assets/current_plan.png";
import tick from "../../Assets/Path 5267.svg";
import cross from "../../Assets/cross.png";
const OurPlans = ({ data }) => {
  const [activePlan, setActivePlan] = useState("3");

  const handleSelect = (e) => {
    setActivePlan(e.id);
  };
  return (
    <>
      <div className={" our_plans_section"}>
        <div className="partner_header">
          <h2>Our Plan</h2>
        </div>
        <div className="our_plan_hero">
          <div className="row">
            <div className="col-8 col-sm-6 col-md-4 col-lg-3">
              <div className="feature_box">
                <h2>Features</h2>
                <div className="row w-100 gx-0">
                  {data?.features?.map((feature) => {
                    return (
                      <div className="col-lg-12">
                        <div className="feature_list">
                          <span>{feature.title}</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="col-4 col-sm-6 col-md-8 col-lg-9 our_plan_col">
              <div className="our_plan_row">
                <div className="row justify-content-between">
                  {data?.category?.map((d, i) => {
                    return (
                      <div
                        key={i}
                        // className={`${d.curentPlan} plan_ca col-2 col-sm-2 col-md-2 col-lg-2 p-0`}
                        className={
                          " plan_ca col-2 col-sm-2 col-md-2 col-lg-2 p-0"
                        }
                        onClick={() => handleSelect(d)}
                      >
                        <div
                          className={
                            // activePlan === d.id
                            d.is_popular
                              ? "active_fib feature_item_box"
                              : "feature_item_box"
                          }
                        >
                          {d.is_popular === true ? (
                            <div className="popular_text">Popular</div>
                          ) : null}
                          <div className="fib_head">
                            <img
                              className="cp_img"
                              src={currentPlanImg}
                              alt="..."
                            />
                            <div className="row">
                              <h5>{d.name}</h5>
                            </div>
                            <div className="row">
                              <h2>{d.pricing}</h2>
                            </div>
                            <div className="row">
                              <span>{d.small_txt}</span>
                            </div>
                          </div>
                          <div className="row">
                            {d.feature_switch.map((v, i) => {
                              return (
                                <div key={i} className="col-lg-12">
                                  <div
                                    className={
                                      v.included
                                        ? "flist bg-white"
                                        : "flist bg-light"
                                    }
                                  >
                                    <img
                                      src={v.included ? tick : cross}
                                      alt="..."
                                    />
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                          <div className="row">
                            <Link to="/plan/payment-method">
                              <button className="home_form_btn">
                                Subscribe
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OurPlans;
